<template>
<div>

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" />

    <b-modal
        :active.sync="showingCopyInfoDetails"
        has-modal-card
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-modal>
        <session-details-modal
            v-bind:day="toMoment(form.startDate).format(config.dateFormat || 'DD/MM/YYYY')"
            v-bind:time="toMoment(form.startDate).format(config.timeFormat || 'HH:mm')"
            v-bind:url="urlCreated"
            v-bind:pin="form.pin"
            v-bind:texts="texts"
        />
    </b-modal>

    <h1 class="title">{{ texts.notification }}</h1>

    <div class="page-form">

        <b-field
            v-if="isAdmin"
            :label="`${texts.professional} (*)`"
        >
            <b-select
                v-model="selectedProfessional"
                :placeholder="texts.select"
                expanded
            >
                <option
                    v-for="prof in professionals"
                    :value="prof.username"
                    :key="prof.username">
                    {{ prof.username }}
                </option>
            </b-select>
        </b-field>

        <b-field
            :label="`${texts.user} (*)`"
            :message="errors.user ? texts.errors.user : undefined"
            :type="errors.user ? 'is-danger' : undefined"
        >
            <b-input
                v-model="form.user"
                :placeholder="texts.user"
            />
        </b-field>

        <b-field
            v-if="config.whens"
            :message="errors.selectedWhen ? texts.errors.selectedWhen : undefined"
            :label="`${texts.when.label} (*)`"
        >
            <b-select
                v-model="form.selectedWhen"
                :placeholder="texts.select"
                expanded
            >
                <option
                    v-for="when in config.whens"
                    :value="when.value"
                    :key="when.value">
                    {{ when.desc }}
                </option>
            </b-select>
        </b-field>

        <b-field
            v-if="config && texts && form.selectedWhen === 'more'"
            :message="errors.startDate ? texts.errors.startDate : undefined"
            :type="errors.startDate ? 'is-danger' : undefined"
        >
            <b-datetimepicker
                rounded
                :placeholder="texts.select"
                icon="calendar"
                horizontal-time-picker
                v-model="form.startDate"
                :datepicker="{
                    minDate: minDate(),
                    maxDate: maxDate(),
                    dayNames: texts.when.days,
                    monthNames: texts.when.months,
                    firstDayOfWeek: config.firstDayWeek,
                    yearsRange: [-1, 1]
                }"
            />
        </b-field>

        <!--
        <b-field
            :label="`${texts.endDate} (*)`"
            :message="errors.endDate ? texts.errors.endDate : undefined"
            :type="errors.endDate ? 'is-danger' : undefined"
        >
            <b-datetimepicker
                rounded
                :placeholder="texts.select"
                icon="calendar"
                horizontal-time-picker
                v-model="form.endDate"
            />
        </b-field>
        -->

        <b-field
            :label="`${texts.notificationMethod} (*)`"
            :message="errors.notificationMethod ? texts.errors.notificationMethod : undefined"
            :type="errors.notificationMethod ? 'is-danger' : undefined"
        >
            <b-select
                v-model="selectedNotification"
                :placeholder="texts.select"
                expanded
            >
                <option
                    v-for="notif in notificationMethods"
                    :value="notif.name"
                    :key="notif.name">
                    {{ notif.display }}
                </option>
            </b-select>
        </b-field>

        <b-field
            v-if="selectedNotificationHasParam"
            :message="errors.notificationParam ? texts.errors.notificationParam : undefined"
            :type="errors.notificationParam ? 'is-danger' : undefined"
        >
            <b-input v-model="form.notificationParam" :placeholder="selectedNotificationParamName" />
        </b-field>

        <b-field>
            <b-checkbox v-model="form.autoConnect">
                {{ texts.autoConnect }}
            </b-checkbox>
        </b-field>

        <b-field
            v-show="!form.autoConnect"
            :label="texts.pin"
            :message="errors.pin ? texts.errors.pin : undefined"
            :type="errors.pin ? 'is-danger' : undefined"
        >
            <b-input v-model="form.pin" :placeholder="texts.pin" />
        </b-field>

        <b-field
            v-if="config.showDetails === true || config.showDetails === false"
        >
            <b-checkbox v-model="form.showDetails">
                {{ texts.showDetails }}
            </b-checkbox>
        </b-field>

        <b-field
            v-show="serverConfig.payments === 'enabled'"
        >
            <b-checkbox v-model="form.payment">
                {{ texts.payment }}
            </b-checkbox>
        </b-field>

        <b-field
            v-show="form.payment"
            :label="texts.price + ' (' + serverConfig.currency + ')'"
        >
            <b-input v-model="form.price" :placeholder="texts.price" />
        </b-field>

        <b-field
            v-if="config.userId === true"
        >
            <b-checkbox v-model="form.userIdCheck">
                {{ texts.userId }}
            </b-checkbox>
        </b-field>

        <b-field
            v-if="form.userIdCheck"
        >
            <b-input v-model="form.userId" :placeholder="texts.userIdMsg" />
        </b-field>

    </div>

    <div class="actions">
        <button class="button is-warning actions-btn" @click="back()">
            <b-icon
                pack="fas"
                icon="undo-alt">
            </b-icon>
        </button>
        <button class="button is-info actions-btn" @click="createSession()">
            <b-icon
                pack="fas"
                icon="paper-plane">
            </b-icon>
        </button>
    </div>

</div>
</template>

<script>
import moment from 'moment';
import { Utils } from '../../mixins/Utils';
import HealthCareService from '../../services/HealthCareService';

const SessionDetailsModal = {
    props: ['day', 'time', 'url', 'pin', 'texts'],
    template: `
        <form style="max-width:90%;margin:0 auto;text-align:left">
            <div class="modal-card">
                <section class="modal-card-body" id="text-to-copy" style="overflow-wrap: break-word;">
                    {{ formatMsg() }}
                </section>
                <footer class="modal-card-foot">
                    <button class="button is-info" @click="copyText">{{ texts.copyText }}</button>
                    <button class="button is-info" @click="copyUrl">{{ texts.copyUrl }}</button>
                    <button class="button" type="button" @click="$router.push('/professional/call')">{{ texts.close }}</button>
                </footer>
            </div>
        </form>
    `,
    methods: {
        formatMsg() {
            let msg = this.texts.copyMsg;
            msg = msg.replace('__DAY__', this.day);
            msg = msg.replace('__TIME__', this.time);
            msg = msg.replace('__URL__', this.url);
            if (this.pin) msg += ` ${this.texts.pin}: ${this.pin}`;
            return msg;
        },
        copyUrl(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            this.$clipboard(this.url);
            this.$buefy.toast.open({ message: this.texts.copied, type: 'is-success', position: 'is-bottom' });
        },
        copyText(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            this.$clipboard(document.getElementById("text-to-copy").textContent);
            this.$buefy.toast.open({ message: this.texts.copied, type: 'is-success', position: 'is-bottom' });
        }
    }
};

export default {
    name: 'Create',
    components: {
        SessionDetailsModal
    },
    mixins: [ Utils ],
    data () {
        return {
            isLoading: false,
            config: {},
            serverConfig: {},
            texts: {},
            isAdmin: false,
            notificationMethods: [],
            professionals: [],
            selectedProfessional: null,
            selectedNotification: null,
            selectedNotificationHasParam: false,
            selectedNotificationParamName: null,
            form: {
                selectedWhen: 0,
                startDate: null,
                //endDate: null,
                user: null,
                notificationParam: null,
                pin: undefined,
                autoConnect: true,
                showDetails: null,
                payment: false,
                price: undefined,
                userIdCheck: false,
                userId: undefined,
            },
            errors: {
                selectedWhen: null,
                startDate: null,
                //endDate: null,
                user: null,
                notificationMethod: null,
                notificationParam: null,
                pin: null,
            },
            showingCopyInfoDetails: false,
            urlCreated: null
        }
    },
    mounted() {
        this.config = JSON.parse(JSON.stringify(this.$parent.config));
        this.texts = JSON.parse(JSON.stringify(this.$parent.texts));
        this.form.startDate = moment().add(3, 'hours').toDate();
        if (!HealthCareService.isLogged()) this.$router.push('/');
        this.isAdmin = HealthCareService.isAdmin();
        this.loadNotificationMethods();
        if (this.isAdmin) this.loadProfessionals();
        this.selectedProfessional = this.isAdmin ? localStorage.getItem('user') : null;
        this.form.showDetails = this.config.showDetails === true || this.config.showDetails === false ? this.config.showDetails : null;
        this.loadServerConfig();
    },
    methods: {
        showCopyInfoDialog() {
            this.showingCopyInfoDetails = true;
        },
        minDate() {
            return moment().toDate();
        },
        maxDate() {
            return moment().add('1', 'year').toDate();
        },
        toMoment(date) {
            return moment(date);
        },
        validateCreateForm() {
            this.errors.startDate = !this.form.startDate;
            this.errors.user = !this.form.user;
            this.errors.notificationMethod = !this.selectedNotification;
            this.errors.notificationParam = this.selectedNotificationHasParam && !this.form.notificationParam;
            this.errors.pin = this.form.pin && !/([0-9]{4})/.test(parseInt(this.form.pin, 10));
            let isValid = true;
            for (let field in this.errors) {
                if (this.errors.hasOwnProperty(field)) {
                    if (this.errors[field] === true) isValid = false;
                }
            }
            return isValid;
        },
        back() {
            this.$router.push('/professional/call');
        },
        createSession() {
            const isValid = this.validateCreateForm();
            if (!isValid) return;
            if (this.form.selectedWhen === parseInt(this.form.selectedWhen, 10)) {
                // Integer
                this.form.startDate = moment().add(this.form.selectedWhen, 'minutes').toDate();
            }
            else if (this.form.selectedWhen === 'more') {
                // More
            }
            else {
                return;
            }
            this.isLoading = true;
            HealthCareService.createSession({
                "startDate": this.form.startDate.toISOString(),
                "endDate": moment(this.form.startDate).add(this.config.duration, 'hours').toDate().toISOString(),
                "pin": this.form.pin || undefined,
                "user": this.form.user,
                "userId": this.form.userId || undefined,
                "notificationMethod": this.selectedNotification,
                "notificationParam": this.form.notificationParam || undefined,
                "autoConnect": this.form.autoConnect,
                "professional": (this.isAdmin && this.selectedProfessional !== localStorage.getItem('user')) ? this.selectedProfessional : undefined,
                "price": this.form.payment ? this.form.price : undefined,
            })
            .then(res => {
                this.$buefy.toast.open({ message: this.texts.notificationSent, type: 'is-success', position: 'is-bottom' });
                setTimeout(() => {
                    this.isLoading = false;
                    if (this.form.showDetails) {
                        this.urlCreated = res.data.url;
                        this.showCopyInfoDialog();
                    }
                    else this.$router.push('/professional/call');
                }, 1000);
            })
            .catch(error => {
                this.isLoading = false;
                const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
            })
        },
        loadNotificationMethods() {
            HealthCareService.getNotificationMethods()
                .then(res => {
                    this.notificationMethods = res.data.methods;
                    if (this.notificationMethods.length > 0) this.selectedNotification = this.notificationMethods[0].name;
                })
                .catch(error => {
                    const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                    this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                })
        },
        loadProfessionals() {
            HealthCareService.getProfessionals()
                .then(res => {
                    this.professionals = res.data;
                })
                .catch(error => {
                    const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                    this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                })
        },
        loadServerConfig() {
            HealthCareService.getConfig()
                .then(res => {
                    this.serverConfig = res.data;
                    if (this.serverConfig.payments === 'enabled') this.form.price = this.serverConfig['default-price'];
                })
                .catch(error => {
                    const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                    this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                })
        },
    },
    watch: {
        selectedNotification(newVal, oldVal) {
            this.form.notificationParam = null;
            const res = this.notificationMethods.filter(notif => notif.name === newVal);
            this.selectedNotificationHasParam = res[0].hasParam;
            this.selectedNotificationParamName = res[0].hasParam ? res[0].paramName : null;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page-form {
    width: 500px;
    max-width: 90%;
    margin: 0 auto;
    text-align: left;
}
.actions {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    .actions-btn {
        border-radius: 30px;
        height: 60px;
        width: 60px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/professional/Create.vue